module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAxUlEQVR4Ae3NAQYCYRRF4aPSAiJCCCHSXlpBewi0iHbQFhIFtI5gMDAKwyAIgF40RMYD8y6D/1wAvksnSqWW3DFODJE0p8K+uzJQ8CX22yX6YvbH1xd9AttijR3pEdgea+xAQCs27sUrgn/ydi/OEbxhzkXGOIR3LvIg3rkomNCqRc07FzumbfkKw/wLDV9frJW8cWOUeBk/V/MlPp+p+XHiZfxMzT/w+VzNTzrNo+ZR86h576CI4nH4KVGpedQ8Aj6VCugDzRCyY7Fly6EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_edit_black_24dp.png
// module id = 122
// module chunks = 0